import React from 'react';
// import { Navigate } from 'react-router-dom';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  // const accessToken = localStorage.getItem('access_token');
  

  // if (!accessToken) {
  //   // Si l'utilisateur n'est pas authentifié, redirigez-le vers la page de connexion.
  //   return <Navigate to="/" />;
  // }

  // Si l'utilisateur est authentifié, rendez le composant enfant.
  return children;
};

export default PrivateRoute;